<div class="row">

    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Nombres:" type="text" [value]="employee.firstName" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Apellido Paterno:" type="text" [value]="employee.firstLastName" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Apellido Materno:" type="text" [value]="employee.secondLastName" [disabled]="disabled">
      </mat-form-field>
    </div>
  
  </div>
  <div class="row">
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="RFC:" type="text" [value]="employee.taxationIdentificationNumber" [disabled]="disabled">
      </mat-form-field>
    </div>
  
    <div class="col-md-4">
      <mat-form-field class="col-sm-12">
        <input matInput placeholder="Documento Legal:" type="text" [value]="employee.nationalIdentificationNumber" [disabled]="disabled">
      </mat-form-field>
    </div>
  
  </div>